import React from "react";
import { Link, Outlet } from "react-router-dom";

function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-light-bg font-sans">
      {/* Header */}
      <header className="bg-brand-blue text-white shadow-md sticky top-0 z-10">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <Link
            to="/"
            className="text-2xl font-bold hover:opacity-90 transition-opacity"
          >
            TTS
          </Link>
          <nav className="flex items-center space-x-4">
            <Link
              to="/"
              className="text-sm hover:text-blue-200 transition-colors"
              title="Home"
            >
              Home
            </Link>
            <Link
              to="/analyzer"
              className="text-sm hover:text-blue-200 transition-colors"
              title="Tension Analyzer"
            >
              Analyzer
            </Link>
            <Link
              to="/privacy"
              className="text-sm hover:text-blue-200 transition-colors"
              title="Privacy Policy"
            >
              Privacy
            </Link>
            <Link
              to="/coach"
              className="text-sm hover:text-blue-200 transition-colors"
              title="String Coach"
            >
              Coach
            </Link>
          </nav>
        </div>
      </header>

      {/* Main Content - Outlet renders the matched child route */}
      <main className="flex-grow">
        <Outlet /> {/* Child routes will be rendered here */}
      </main>

      {/* Footer */}
      <footer className="bg-dark-text text-gray-400 py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} The Tennis Strings. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
